export default "__VITE_ASSET__facbb882__"